import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LoginService } from 'src/app/services/login/login.service';
import { PopupService } from 'src/app/services/popup/popup.service';

@Component({
  selector: 'app-expired-token-popup',
  templateUrl: './expired-token-popup.component.html',
  styleUrls: ['./expired-token-popup.component.scss']
})
export class ExpiredTokenPopupComponent  implements OnInit{
  constructor(
    private loginService: LoginService,
    private dialogRef: MatDialogRef<ExpiredTokenPopupComponent>,
    private popupService: PopupService

) {
}
  ngOnInit(): void {
    }

login() {
  this.popupService.setPopupOpen(false);
  this.loginService.logOutOnce();
  this.loginService.login(true);
  this.dialogRef.close(); 
 

}
}
